export const VACCINE_ROOT_PATH = '/vaccine';
export const VACCINE_APPOINTMENTS_BASE_PATH = `${VACCINE_ROOT_PATH}/appointments`;
export const VACCINE_APPOINTMENTS_PATH = `${VACCINE_APPOINTMENTS_BASE_PATH}/:appointmentNumber`;
